var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwittericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#1DA1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9432 21.4147C17.9827 21.4147 21.286 16.411 21.286 12.0719C21.286 11.9299 21.286 11.7883 21.2764 11.6475C21.9191 11.1826 22.4737 10.6072 22.9146 9.94777C22.3153 10.2133 21.6795 10.3875 21.0285 10.4644C21.714 10.0539 22.2271 9.4086 22.4721 8.6482C21.8275 9.03071 21.1224 9.3003 20.3871 9.44523C19.1435 8.1229 17.0635 8.05906 15.7411 9.30261C14.8883 10.1046 14.5266 11.2996 14.7912 12.44C12.1513 12.3076 9.6914 11.0606 8.02407 9.00919C7.15254 10.5095 7.59764 12.429 9.04072 13.3925C8.51808 13.377 8.007 13.236 7.55034 12.9815C7.55034 12.995 7.55034 13.0091 7.55034 13.0231C7.55069 14.5863 8.65252 15.9324 10.1847 16.242C9.70135 16.3738 9.19401 16.3932 8.70196 16.2984C9.13212 17.636 10.3648 18.5524 11.7697 18.5787C10.6069 19.4925 9.17054 19.9885 7.69171 19.9871C7.43048 19.9866 7.16961 19.9707 6.91016 19.9396C8.41174 20.9033 10.1591 21.4143 11.9432 21.412",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittericon);
export default __webpack_public_path__ + "static/media/twittericon.1ca3a94c.svg";
export { ForwardRef as ReactComponent };